'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { InfluencerSectionWidgetDS } from './influencer-section-widget-ds'
import { InfluencerSectionWidgetLegacy } from './influencer-section-widget-legacy'

import type { InfluencerSectionWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

function InfluencerSectionWidgetComponent(props: PLTypedWidgetProps<InfluencerSectionWidgetData>) {
  return shouldUseDesignSystem() ? (
    <InfluencerSectionWidgetDS {...props} />
  ) : (
    <InfluencerSectionWidgetLegacy {...props} />
  )
}

export const InfluencerSectionWidget: PLTypedWidgetInterface<
  InfluencerSectionWidgetData,
  WidgetType.INFLUENCER_SECTION
> = {
  id: WidgetType.INFLUENCER_SECTION,
  errorBoundary: PLBaseErrorBoundary,
  render: InfluencerSectionWidgetComponent,
}
